module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("dJ9Ng"))).then(() => parcelRequire('g4daj'));